<template>
  <div id="home" :class="{'home-anim-active': isHomeAnimActive}">
    <div class="page-shadow">
      <v-touch ref="tapper" v-on:swiperight="prevGround" v-on:swipeleft="nextGround">
        <div class="home">
          <div class="inside">
            <div class="container clearfix home-container">
              <div class="heading">
                <transition name="headerText">
                  <h2 v-if="!isHomeAnimActive || isHomeAnimActive && mounted">{{$t('home.headingTopText')}}</h2>
                </transition>
                <transition name="firstText">
                  <p v-if="!isHomeAnimActive || isHomeAnimActive && mounted" v-html="$t('home.headingSubText')"></p>
                </transition>
                <transition name="secondText">
                  <span v-if="!isHomeAnimActive || isHomeAnimActive && mounted" v-html="$t('home.headingBottomText')"
                        class="text"></span>
                </transition>
                <div class="mobile-height" :class="{'anim-height': animFinished || !isHomeAnimActive}"></div>
              </div>
              <transition name="boxes">
                <div v-if="!isHomeAnimActive || isHomeAnimActive && mounted" class="boxes">
                  <div class="arrows">
                    <div class="arrow arrow-prev" @click="prevGround"></div>
                    <div class="arrow arrow-next" @click="nextGround"></div>
                  </div>
                  <transition name="box-1">
                    <router-link to="/products/farms/presentation" class="box farm-box"
                                 v-bind:class="{current : grounds[mobileOption] === 'farm', next : mobileOption < 0, prev : mobileOption > 0}"
                                 id="farmGround">
                      <div v-on:mouseover="farmHover" v-on:mouseleave="farmLeave">
                        <div class="area"></div>
                        <div class="icon">
                          <img src="../../static/img/home/wind-farm.svg" alt="wind-farm"/>
                          <p class="big">
                            <span v-html="$t('home.farms')"></span>
                          </p>
                        </div>
                        <div class="subtitle">
                        <p>
                          Bioseco BIRD PROTECTION SYSTEM (BPS)
                        </p>
                      </div>
                      </div>
                    </router-link>
                  </transition>
                  <transition name="box-2">
                    <router-link to="/products/airport/presentation" class="box big airport-box"
                                 v-bind:class="{current : grounds[mobileOption] === 'airport', next : mobileOption < 1, prev : mobileOption > 1}"
                                 id="airportGround">
                      <div v-on:mouseover="airportHover" v-on:mouseleave="airportLeave">
                        <div class="area"></div>
                        <div class="icon">
                          <img src="../../static/img/home/airport.svg" alt="airport"/>
                          <p class="big">
                            <span v-html="$t('home.airports')"></span>
                          </p>
                        </div>
                        <div class="subtitle">
                        <p>
                          Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)
                        </p>
                      </div>
                      </div>
                    </router-link>
                  </transition>
                  <transition name="box-3">
                    <router-link to="/products/area/presentation" class="box area-box"
                                 v-bind:class="{current : grounds[mobileOption] === 'area' , next : mobileOption < 2, prev : mobileOption > 2}"
                                 id="forestGround">
                      <div v-on:mouseover="forestHover" v-on:mouseleave="forestLeave">
                        <div class="area"></div>
                        <div class="icon">
                          <img src="../../static/img/home/area.svg" alt="area"/>
                          <p class="big">
                            <span v-html="$t('home.area')"></span>
                          </p>
                        </div>
                        <div class="subtitle">
                        <p>
                          Bioseco BIRD PROTECTION SYSTEM (BPS)
                        </p>
                      </div>
                      </div>
                    </router-link>
                  </transition>

                </div>
              </transition>
              <transition name="scroll">
                <a v-if="!isHomeAnimActive || isHomeAnimActive && mounted"
                   @click="(e) => {smoothScroll(e); this.animFinished = true; }" href="#aboutUs" data-scroll-offset="60"
                   class="more-about-us"><span>{{$t('moreAboutUs')}}</span></a>

              </transition>
            </div>
          </div>

        </div>
      </v-touch>
      <FooterOrange :isAnim="isHomeAnimActive"/>
    </div>

    <AboutUs :isHome="true"></AboutUs>
  </div>
</template>

<script>
  import FooterOrange from "../components/FooterOrange";
  import AboutUs from "../pages/AboutUs";
  import store from "../store/store";
  import smoothScroll from "../helpers/SmoothScroll";

  export default {
    name: "home",
    data() {
      return {
        animFinished: false,
        mounted: false,
        farmDOM: null,
        airportDOM: null,
        forestDOM: null,
        grounds: ["farm", "airport", "area"],
        mobileOption: 1
      };
    },
    mounted: function () {
      this.mounted = true;
      store.commit("SHOW_CANVAS");

      if (this.isHomeAnimActive) {
        setTimeout(() => {
          this.animFinished = true;
          store.commit("SHOW_GROUNDS");
        }, 5500);
      } else {

        store.commit("SET_MOBILE_ACTIVE", {
          ground: "airport",
          dir: 1
        });
      }
    },
    destroyed() {
      store.commit("CLEAR_HOME_MOUSE_EVENTS");
      store.commit("HIDE_CANVAS");
      store.commit("HOME_ANIM_FINISHED");
    },
    methods: {
      farmHover: function () {
        store.commit("FARM_MOUSE_HOVER");
      },
      farmLeave: function () {
        store.commit("FARM_MOUSE_LEAVE");
      },
      airportHover: function () {
        store.commit("AIRPORT_MOUSE_HOVER");
      },
      airportLeave: function () {
        store.commit("AIRPORT_MOUSE_LEAVE");
      },
      forestHover: function () {
        store.commit("FOREST_MOUSE_HOVER");
      },
      forestLeave: function () {
        store.commit("FOREST_MOUSE_LEAVE");
      },
      nextGround: function () {
        if (window.innerWidth > 780 || !this.animFinished) return;
        this.mobileOption =
          this.mobileOption + 1 >= this.grounds.length
            ? this.mobileOption
            : this.mobileOption + 1;
        store.commit("SET_MOBILE_ACTIVE", {
          ground: this.grounds[this.mobileOption],
          dir: 1
        });
      },
      prevGround: function () {
        if (window.innerWidth > 780 || !this.animFinished) return;
        this.mobileOption =
          this.mobileOption - 1 <= 0 ? 0 : this.mobileOption - 1;
        store.commit("SET_MOBILE_ACTIVE", {
          ground: this.grounds[this.mobileOption],
          dir: -1
        });
      }
    },
    computed: {
      isHomeAnimActive() {
        return store.state.isHomeAnimActive;
      },
      loaded() {
        return store.state.isAppLoaded;
      },
      smoothScroll: () => smoothScroll
    },
    components: {
      FooterOrange,
      AboutUs
    }
  };
</script>


<style scoped>

  .home-anim-active .show-enter-active,
  .home-anim-active .show-leave-active {
    transform: translate(0);
    transition: transform 0.5s 1s;
  }

  .home-anim-active .show-enter,
  .home-anim-active .show-leave-to {
    transform: translateY(100%);
  }

  .home-anim-active .headerText-enter-active,
  .home-anim-active .headerText-leave-active {
    opacity: 1;
    transition: all 0.5s 1.15s;
  }

  .home-anim-active .headerText-enter,
  .home-anim-active .headerText-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .home-anim-active .firstText-enter-active,
  .home-anim-active .firstText-leave-active {
    max-height: 22px;
    opacity: 1;
    transition: all 0.5s 2.5s;
  }

  .home-anim-active .firstText-enter,
  .home-anim-active .firstText-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .home-anim-active .secondText-enter-active,
  .home-anim-active .secondText-leave-active {
    max-height: 30px;
    opacity: 1;
    transition: all 0.5s 4s;
  }

  .home-anim-active .secondText-enter,
  .home-anim-active .secondText-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .home-anim-active .boxes-enter-active,
  .home-anim-active .boxes-leave-active {
    max-height: 500px;
    transition: all 1s 6s;
  }

  .home-anim-active .boxes-enter,
  .home-anim-active .boxes-leave-to {
    max-height: 0;
  }

  .home-anim-active .boxes-enter-active > .box,
  .home-anim-active .boxes-leave-active > .box {
    pointer-events: none;
  }

  .home-anim-active .boxes-enter-active > .box,
  .home-anim-active .boxes-leave-active > .box {
    opacity: 1;
    transform: translateY(0);
    transition: all 1s;
  }

  .home-anim-active .box.farm-box,
  .home-anim-active .box.farm-box {
    transition-delay: 6s;
  }

  .home-anim-active .box.airport-box,
  .home-anim-active .box.airport-box {
    transition-delay: 6.2s;
  }

  .home-anim-active .box.area-box,
  .home-anim-active .box.area-box {
    transition-delay: 6.4s;
  }

  .home-anim-active .boxes-enter .box,
  .home-anim-active .boxes-leave-to .box {
    opacity: 0;
    transform: translateY(20px);
  }

  .home-anim-active .scroll-enter-active,
  .home-anim-active .scroll-leave-active {
    opacity: 1;
    transition: all 0.5s 6s;
    transform: translateY(0px);
  }

  .home-anim-active .scroll-enter,
  .home-anim-active .scroll-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }
</style>



// WEBPACK FOOTER //
// Home.vue?3a820a62